// leinwand.js — der Weg zur Anzeige unter /formen-display.
//
// Beide Schreiber-Panels (Formen und Selbstverteidigung) senden hierueber, und
// zwar auf zwei Wegen gleichzeitig: localStorage erreicht andere Fenster und
// ueberlebt deren Reload, BroadcastChannel erreicht denselben Tab.
//
// Die Anzeige rechnet nichts. Sie zeigt, was hier ankommt.
//
// Seit 18.10.2026 zusätzlich über den Server (lib/leinwandServer.js): mit
// Turnier und Matte (setzeLeinwandZiel) läuft die Leinwand auf jedem Gerät.
import { sendeAnServer, leinwandAdresse } from './leinwandServer';
import { toast } from '../components/common/Toast';
export { setzeLeinwandZiel } from './leinwandServer';

export const LEINWAND_KANAL = 'tda-formen-display';
export const LEINWAND_SPEICHER = 'tda-formen-display-state';
export const LEINWAND_ADRESSE = '/formen-display';

/** Nur die Felder, die auf der Leinwand vorkommen. Geburtsdatum und alles
 *  weitere Personenbezogene hat in localStorage nichts zu suchen. */
export const schlankerTeilnehmer = (tn) => tn && ({
  wettkaempfer_id: tn.wettkaempfer_id,
  startnummer: tn.startnummer,
  vorname: tn.vorname,
  nachname: tn.nachname,
  verein_name: tn.verein_name,
  gurtfarbe: tn.gurtfarbe,
  // Bild auf der Tafel: Foto, sonst Vereinslogo (20.10.2026). Seit 21.10.2026
  // kein Pfad mehr, nur ob das Foto gezeigt werden darf; die Leinwand holt es
  // mit ihrem Hallenschlüssel (lib/hallenbild.js).
  foto_frei: !!tn.foto_frei,
  verein_logo: tn.verein_logo || null,
  // Gewählte Form aus dem Katalog (21.10.2026)
  form_name: tn.form_name || null,
});

/** Starterliste unten auf der Tafel (20.10.2026): Reihenfolge nach
 *  Startnummer, Punkte nur für fertige Starter (aus der API, nicht gerechnet). */
export const schlankeStarterliste = (liste) => (liste || [])
  .slice()
  .sort((a, b) => (a.startnummer || 999) - (b.startnummer || 999))
  .map(tn => ({
    wettkaempfer_id: tn.wettkaempfer_id,
    startnummer: tn.startnummer,
    vorname: tn.vorname,
    nachname: tn.nachname,
    status: tn.status,
    gesamt_punkte: tn.status === 'completed' ? tn.gesamt_punkte : null,
  }));

/** Wer als Nächstes kommt: Name und Verein für „In Vorbereitung“. */
export const schlankeFolgende = (liste) => (liste || []).slice(0, 2).map(t => ({
  wettkaempfer_id: t.wettkaempfer_id,
  startnummer: t.startnummer,
  vorname: t.vorname,
  nachname: t.nachname,
  verein_name: t.verein_name,
}));

export const schlankeRangliste = (liste) => (liste || []).map(tn => ({
  wettkaempfer_id: tn.wettkaempfer_id,
  vorname: tn.vorname,
  nachname: tn.nachname,
  verein_name: tn.verein_name,
  gesamt_punkte: tn.gesamt_punkte,
  status: tn.status,
  platzierung: tn.platzierung,
}));

export function sendeAnLeinwand(paket) {
  const roh = JSON.stringify({ ...paket, gesendet: Date.now() });
  try { localStorage.setItem(LEINWAND_SPEICHER, roh); } catch (e) { /* privater Modus */ }
  try {
    const kanal = new BroadcastChannel(LEINWAND_KANAL);
    kanal.postMessage(JSON.parse(roh));
    setTimeout(() => kanal.close(), 200);
  } catch (e) { /* aeltere Browser: localStorage genuegt */ }
  sendeAnServer('formen', JSON.parse(roh));
}

/** Leinwand oeffnen — moeglichst gleich auf dem zweiten Bildschirm.
 *  Muster aus ErgebnisDashboard (Siegerehrung), inklusive der Eigenheiten von
 *  Firefox und Safari. */
export async function oeffneLeinwand() {
  const name = 'formen-display';

  if ('getScreenDetails' in window && window.screen?.isExtended) {
    try {
      const schirme = await window.getScreenDetails();
      const zweiter = schirme.screens.find(s => !s.isPrimary);
      if (zweiter) {
        window.open(leinwandAdresse(LEINWAND_ADRESSE), name,
          `popup,left=${zweiter.availLeft},top=${zweiter.availTop},width=${zweiter.availWidth},height=${zweiter.availHeight}`);
        return true;
      }
    } catch (e) { /* weiter mit dem Fallback */ }
  }

  const breite = window.screen.width;
  const hoehe = window.screen.availHeight || window.screen.height;
  const links = /Firefox/.test(navigator.userAgent) ? breite : undefined;
  const fenster = window.open(leinwandAdresse(LEINWAND_ADRESSE), name,
    `popup,${links !== undefined ? `left=${links},top=0,` : ''}width=${breite},height=${hoehe},menubar=no,toolbar=no,location=no,status=no`);
  if (!fenster) {
    toast.fehler('Das Fenster wurde vom Browser blockiert. Bitte Pop-ups für diese Seite erlauben.');
    return false;
  }
  if (links !== undefined) { try { setTimeout(() => fenster.moveTo(links, 0), 100); } catch (e) {} }
  return true;
}

export function kopiereLeinwandAdresse() {
  const adresse = `${window.location.origin}${leinwandAdresse(LEINWAND_ADRESSE)}`;
  return navigator.clipboard.writeText(adresse).then(() => adresse);
}
